import { render } from "./price_lists.html?vue&type=template&id=3cd528af&scoped=true&external"
import script from "./price_lists.vue?vue&type=script&lang=js"
export * from "./price_lists.vue?vue&type=script&lang=js"

import "./price_lists.vue?vue&type=style&index=0&id=3cd528af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd528af"]])

export default __exports__